export enum EWebclientSnippet {
  SIMPLE = 'simple',
  ADVANCED = 'advanced',
}
